namespace Areas.Maintenance.List {
    "use strict";

    var selected: Selected = new Selected();

    var maintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["Account", "Contact", "Contract", "ContractSubContractor", "ContractVendor", "NonPlantAccount", "Vendor"])

    var generalMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["Inspectors", "InspectionProjects", "InspectionProjectStatus", "InspectionTypes", "Status", "DailyReportTemplate"])

    var otherTablesMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["RequestAccess"])

    var systemMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["SystemConfigSettings", "SystemProcessEmails", "SystemUsers"])

    export function maintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(maintenanceTabItems)(params);
    }

    export function otherTablesMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(otherTablesMaintenanceTabItems)(params);
    }

    export function systemMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(systemMaintenanceTabItems)(params);
    }

    export function generalMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(generalMaintenanceTabItems)(params);
    }
}
